const isArrayNotEmpty = (value: Array<any>) =>
  Array.isArray(value) && value.length > 0;

export default isArrayNotEmpty;



// WEBPACK FOOTER //
// ./src/services/agestrict/utils/isArrayNotEmpty.ts